
import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslocoService } from '@ngneat/transloco';
import { firstValueFrom } from 'rxjs';
import { SearchResourcesDialogComponent } from '../search-resources-dialog/search-resources-dialog.component';
import { CancelReason } from '../../modules/admin/tasks/tasks.types';
import { DTypeService } from '../../core/dtype/dtype.service';
import { ServicesService } from '../../modules/admin/services/services.service';
import { FuseConfirmationService } from '../../../@fuse/services/confirmation/confirmation.service';

@Component({
    selector: 'app-cancel-task-dialog',
    templateUrl: './cancel-task-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CancelTaskDialogComponent implements OnInit {

    marcaCode: string;
    uri: string;
    control: FormControl = new FormControl('', Validators.required);
    reasonsData: CancelReason[] = [];
    tasksToCancel: string[];
    tasksCantCancel: string[];
    idsCantCancel: string;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
            tasksToCancel: string[];
            tasksCantCancel: string[];
        },
        public dialogRef: MatDialogRef<SearchResourcesDialogComponent>,
        private dtypeService: DTypeService,
        private servicesService: ServicesService,
        private _fuseConfirmationService: FuseConfirmationService,
        private transloco: TranslocoService,
    ) { }

    /**
     * On init
     */
    async ngOnInit() {
        this.tasksToCancel = this.data.tasksToCancel;
        this.tasksCantCancel = this.data.tasksCantCancel;
        this.idsCantCancel = '"';
        for (let i = 0; i < this.tasksCantCancel.length; i++) {
            if ( i !== this.tasksCantCancel.length - 1) {
                this.idsCantCancel = this.idsCantCancel + this.tasksCantCancel[i] + '", "';
            } else {
                this.idsCantCancel = this.idsCantCancel + this.tasksCantCancel[i] + '"';
            }
        }
        this.marcaCode = (await firstValueFrom(this.servicesService.service$)).marca_code;
        this.uri = 'master://Brand=' + this.marcaCode + '/OU=01/CancellationReasons';
        this.reasonsData = await firstValueFrom(this.dtypeService.retrieveDTypeDataCollectionByUri(this.uri));
    }

    async saveReason(action: string) {
        this.control.markAllAsTouched();
        if (action === 'save') {
            if (!this.control.valid) {
                return;
            }
            const reason: CancelReason = this.reasonsData.find(rd => rd.code === this.control.value);
            let confirmSave: boolean;
            if ((this.tasksCantCancel.length + this.tasksToCancel.length) === 1) {
                confirmSave = await this.confirm(this.transloco.translate('warning'), this.transloco.translate('saveCancelReasonUniqueTask'));
            } else {
                confirmSave = await this.confirm(this.transloco.translate('warning'), this.transloco.translate('saveCancelReason'));
            }
            if (confirmSave) {
                this.dialogRef.close(reason);
            }
        } else if (action === 'cancel') {
            const confirmCancel = await this.confirm(this.transloco.translate('warning'), this.transloco.translate('sendNullReason'));
            if (confirmCancel) {
                this.dialogRef.close();
            }
        }
    }

    private confirm(title?: string, message?: string, confirm?: string, cancel?: string) {
        const dialogRef = this._fuseConfirmationService.open({
            title: title ? title : this.transloco.translate('unsavedChanges'),
            message: message ? message : this.transloco.translate('exitWithUnsavedChanges'),
            actions: {
                confirm: {
                    label: confirm ? confirm : this.transloco.translate('accept')
                },
                cancel: {
                    label: cancel ? cancel : this.transloco.translate('cancel')
                }
            }
        });

        return new Promise<boolean>((resolve) => {
            dialogRef.afterClosed().subscribe((result) => {
                if (result === 'confirmed') {
                    resolve(true);
                } else {
                    resolve(false);
                }
            });
        });
    }
}
